export interface ModalInputText {
	chipsQuestion?: string
	inputPlaceholder: string
	inputQuestion: string
}

export interface GeneratedExampleDropdownData {
	bgPrimary: string
	bgSecondary: string
	title: string
}

export interface GeneratedExampleDropdownCollection {
	[key: number]: GeneratedExampleDropdownData
}

export const generatedExampleDropdownData: GeneratedExampleDropdownCollection =
	{
		1: {
			title: 'Simon Says',
			bgPrimary: 'rgba(237, 231, 246, 0.8)',
			bgSecondary: '#D6D4FF',
		},
		2: {
			title: 'Musical Chairs',
			bgPrimary: 'rgba(226, 245, 248, 1)',
			bgSecondary: '#2CAABB',
		},
		3: {
			title: 'Battle Ships',
			bgPrimary: 'rgba(255, 233, 201, 1)',
			bgSecondary: '#FFC876',
		},
		4: {
			title: 'Dress Up',
			bgPrimary: 'rgba(231, 248, 255, 1)',
			bgSecondary: '#72A4EF',
		},
		5: {
			title: 'Leap Frog',
			bgPrimary: 'rgba(228, 244, 216, 1)',
			bgSecondary: '#CCECB7',
		},
		6: {
			title: 'Round Robin',
			bgPrimary: 'rgba(255, 232, 238, 1)',
			bgSecondary: '#FFBECF',
		},
		7: {
			title: 'Teeter Totter',
			bgPrimary: 'rgba(255, 221, 231, 1)',
			bgSecondary: '#FF437B',
		},
		8: {
			title: 'Opposite Day',
			bgPrimary: 'rgba(220, 239, 254, 0.78)',
			bgSecondary: '#4AA4EF',
		},
		9: {
			title: 'Building Blocks',
			bgPrimary: 'rgba(255, 187, 200, 0.22)',
			bgSecondary: '#CD435E',
		},
	}
